module.exports = function getResource(label, vars = []) {
    const resources = {
        birthdayIconText: 'Free birthday gift',
        earnPointsIconText: 'Earn points per dollar',
        redeemTrialIconText: 'Redeem trial size products & sets',
        accessIconText: 'Access to in-store beauty services',
        applePaySignIn: 'Sign in or create a Sephora account to complete your order with Apple Pay.',
        pleaseSignInMessage: 'Please sign in to Sephora',
        emailAddressLabel: 'Email Address',
        emailAddressPlaceholder: 'Email Address',
        whatsYourEmailAddressLabel: 'What is your email address?',
        signInToSaveBIPointsMessage: 'Sign in to save your Beauty Insider points & redeem your free rewards.',
        signInFasterBookingMessage: 'Sign in for faster booking and to save your reservation to your account.',
        haveABIAccountMessage: 'Have a Beauty Insider account? Use the email you signed up with.',
        notYouMessage: 'Not you?',
        haveAPasswordMessage: 'Do you have a sephora.com password?',
        imNewMessage: 'No, I am new to the website',
        iHaveAPasswordMessage: 'Yes, I have a password',
        passwordLabel: 'Password',
        testPasswordLabelMobile: 'Password (6 to 12 characters)',
        passwordPlaceholder: 'Password',
        enterPasswordErrorMessage: 'Please enter your password.',
        forgotPasswordLink: 'Forgot password?',
        staySignedInLabel: 'Keep me signed in',
        createAccountLabel: 'Create your Sephora account',
        applePaySephoraAccountAgreement: 'By tapping “Buy with Apple Pay,” you are registering for Sephora.com, and you agree to our',
        privacyPolicyLink: 'Privacy Policy',
        andText: 'and',
        sephoraTermsOfUse: 'Sephora Terms of Use',
        automaticallyEmailsMessage: ' You will automatically receive emails from Sephora.',
        giftCardsApplePayMessage: 'Gift cards cannot be combined with Apple Pay.',
        signInButtonLabel: 'Sign In',
        buyWithLabel: 'Buy with',
        continueButtonLabel: 'Continue',
        testSignInHeading: 'Sign in to Sephora',
        testNewAccountHeading: 'New to Sephora?',
        testCreateAccount: 'Create Account',
        existingAccountErrorMessage: 'An account already exists for the email address you’ve entered. Please sign in or choose another email address.',
        signIn: 'Sign In',
        showPasswordLinkAriaLabel: 'Show password text',
        hidePasswordLinkAriaLabel: 'Hide password text',
        testBiPropLead: 'Sign up for the Beauty Insider loyalty program for rewards and exclusive benefits:',
        testBiPropGift: 'Get a free birthday gift',
        testBiPropPoints: 'Earn points per dollar',
        testBiPropRedeem: 'Redeem points for trial size products',
        testNewBiPropLead: 'Create an account and join the Beauty Insider loyalty program for free! It’s your ticket to savings, samples and more.',
        testNewBiPropFree: 'Free',
        testNewBiPropBDayGift: 'Birthday Gift',
        testNewBiPropFreeGift: 'Free Birthday Gift',
        testNewBiPropPoints: 'Seasonal Savings Events',
        testNewBiPropRedeem: 'Sample Rewards',
        staySignedInTooltip: 'Selecting this option means you won’t have to sign in as often on this device. For your security, we recommend only doing this on your personal devices.',
        signInToSaveAndRedeemBiPoints1: 'Sign in and check out to save your',
        signInToSaveAndRedeemBiPoints2: `${vars[0]} Beauty Insider points`,
        signInToSaveAndRedeemBiPoints3: '& redeem your free rewards.'
    };

    return resources[label];
};
